import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { Eht } from '../../onboarding/classes/eht';

@Injectable()
export class EhtService {

  constructor(private http: Http) { }

  getEht(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}/${environment.ehtUrl}`, options)
      .map(res => res.json())
  }

  addEht(orgId: number, info: Eht) {
    let data = { eht: info, commit: 'Add', organization_id: orgId };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${environment.organizationsUrl}${orgId}/${environment.ehtUrl}`, data, options)
      .map(res => res.json())
  }

  editEht(orgId: number, id: number, info: Eht) {
    let data = { eht: info, commit: 'Add', organization_id: orgId, id };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${environment.organizationsUrl}${orgId}/organization_setups/ehts/${id}.json`, data, options)
      .map(res => res.json())
  }

  deleteEht(orgId: number, id: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(`${environment.organizationsUrl}${orgId}/organization_setups/ehts/${id}.json`, options)
      .map(res => res.json())
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/eht.service.ts